import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './Xylophone.css';

const noteColors = { C: '#FF4D5C', D: '#FF9F1C', E: '#FFE036', F: '#56E076', G: '#57F9FF', A: '#3D8FE3', B: '#E360AD', c:'#FF4D5C' };

class Xylophone extends PureComponent {
  static propTypes = {
    currentNote: PropTypes.object,
    debug: PropTypes.bool
  };

  colorByNote = (keyNote, selectedNote) => {
    return noteColors[keyNote.toUpperCase()];
  };

  translateSelector = selectedNote => {
    const positions = {
      C: 0,
      D: 42.797,
      E: 85.594,
      F: 128.392,
      G: 171.189,
      A: 213.986,
      B: 256.783,
      c: 299.58
    };
    if (!(selectedNote in positions)) return 'translate(-50 -50)';
    return 'translate(' + positions[selectedNote] + ' 41)';
  };

  renderSvg = (note, noteNumber) => {
    const cursorWidth = 24;
    const cursorHeight = 30;
    // TODO: usare noteNumber
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="360" height="160" viewBox="0 0 360 160">
        <g id="Group_175" data-name="Group 175" transform="translate(-460 -537.5)">
          <path
            id="Path_418"
            data-name="Path 418"
            d="M0,0H32.8V150.989a3.005,3.005,0,0,1-3,3.011H3a3.005,3.005,0,0,1-3-3.011Z"
            transform="translate(473.279 543)"
            fill="#ff4d5c"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_396"
            data-name="Path 396"
            d="M0,0H32.8V147.978a3.005,3.005,0,0,1-3,3.011H3a3.005,3.005,0,0,1-3-3.011Z"
            transform="translate(516.076 543)"
            fill="#ff9f1c"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_417"
            data-name="Path 417"
            d="M0,0H32.8V138.5a3.006,3.006,0,0,1-3,3.011H3A3.006,3.006,0,0,1,0,138.5Z"
            transform="translate(558.874 543)"
            fill="#ffe036"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_397"
            data-name="Path 397"
            d="M0,0H32.8V133.729a3.006,3.006,0,0,1-3,3.012H3a3.006,3.006,0,0,1-3-3.012Z"
            transform="translate(601.671 543)"
            fill="#56e076"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_416"
            data-name="Path 416"
            d="M0,0H32.8V126.069a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3Z"
            transform="translate(644.468 543)"
            fill="#57f9ff"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_415"
            data-name="Path 415"
            d="M0,0H32.8V118.352a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3Z"
            transform="translate(687.265 543)"
            fill='#3D8FE3'
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_414"
            data-name="Path 414"
            d="M0,0H32.8V113.916a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3Z"
            transform="translate(730.062 543)"
            fill="#e360ad"
            stroke="#000"
            strokeWidth="1"
          />
          <path
            id="Path_398"
            data-name="Path 398"
            d="M0,0H32.8V105.933a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3Z"
            transform="translate(772.859 543)"
            fill="#ff4d5c"
            stroke="#000"
            strokeWidth="1"
          />
          <rect
            id="Rectangle_323"
            data-name="Rectangle 323"
            width="360"
            height="8.118"
            transform="translate(460 553.27)"
            fill="#000"
          />
          <rect
            id="Rectangle_324"
            data-name="Rectangle 324"
            width="360"
            height="8.118"
            transform="translate(460 626.204)"
            fill="#000"
          />
          <g id="Group_156" data-name="Group 156" transform="translate(473.279 538)">
            <path
              id="key1"
              data-name="Path 413"
              d="M0,0H32.8V150.989a3.005,3.005,0,0,1-3,3.011H3a3.005,3.005,0,0,1-3-3.011Z"
              transform="translate(0 0)"
              fill={this.colorByNote('C')}
              stroke="#000"
              strokeWidth="1"
            />
            <path
              id="key2"
              data-name="Path 395"
              d="M0,0H32.8V147.978a3.005,3.005,0,0,1-3,3.011H3a3.005,3.005,0,0,1-3-3.011Z"
              transform="translate(42.797 0)"
              fill={this.colorByNote('D')}
              stroke="#000"
              strokeWidth="1"
            />
            <path
              id="key3"
              data-name="Path 412"
              d="M0,0H32.8V138.5a3.006,3.006,0,0,1-3,3.011H3A3.006,3.006,0,0,1,0,138.5Z"
              transform="translate(85.594 0)"
              fill={this.colorByNote('E')}
              stroke="#000"
              strokeWidth="1"
            />
            <path
              id="key4"
              data-name="Path 394"
              d="M0,0H32.8V133.729a3.006,3.006,0,0,1-3,3.012H3a3.006,3.006,0,0,1-3-3.012Z"
              transform="translate(128.392 0)"
              fill={this.colorByNote('F')}
              stroke="#000"
              strokeWidth="1"
            />
            <path
              id="key5"
              data-name="Rectangle 329"
              d="M0,0H32.8a0,0,0,0,1,0,0V126.069a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z"
              transform="translate(171.189 0)"
              fill={this.colorByNote('G')}
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="key6"
              data-name="Rectangle 330"
              d="M0,0H32.8a0,0,0,0,1,0,0V118.352a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z"
              transform="translate(213.986 0)"
              fill={this.colorByNote('A')}
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="key7"
              data-name="Rectangle 331"
              d="M0,0H32.8a0,0,0,0,1,0,0V113.916a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z"
              transform="translate(256.783 0)"
              fill={this.colorByNote('B')}
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="key8"
              data-name="Rectangle 332"
              d="M0,0H32.8a0,0,0,0,1,0,0V105.933a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3V0A0,0,0,0,1,0,0Z"
              transform="translate(299.58 0)"
              fill={this.colorByNote('c')}
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
            <path
              id="cursor"
              data-name="cursor"
              d={`M16 0 l ${cursorWidth / 2} ${cursorHeight / 2} l-${cursorWidth / 2} ${cursorHeight /
                2} l -${cursorWidth / 2} -${cursorHeight / 2}Z`}
              transform={this.translateSelector(note)}
              fill="black"
              stroke="#000"
              strokeMiterlimit="10"
              strokeWidth="1"
            />
          </g>
          <circle
            id="Ellipse_205"
            data-name="Ellipse 205"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(485.878 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_206"
            data-name="Ellipse 206"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(485.878 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_207"
            data-name="Ellipse 207"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(528.675 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_208"
            data-name="Ellipse 208"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(528.675 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_209"
            data-name="Ellipse 209"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(571.473 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_210"
            data-name="Ellipse 210"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(571.473 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_211"
            data-name="Ellipse 211"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(614.27 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_212"
            data-name="Ellipse 212"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(614.27 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_213"
            data-name="Ellipse 213"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(657.067 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_214"
            data-name="Ellipse 214"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(657.067 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_215"
            data-name="Ellipse 215"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(699.864 626.464)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_216"
            data-name="Ellipse 216"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(699.864 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_217"
            data-name="Ellipse 217"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(742.661 626.687)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_218"
            data-name="Ellipse 218"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(742.661 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_219"
            data-name="Ellipse 219"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(785.459 626.687)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
          <circle
            id="Ellipse_220"
            data-name="Ellipse 220"
            cx="3.799"
            cy="3.799"
            r="3.799"
            transform="translate(785.459 553.529)"
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="1"
          />
        </g>
      </svg>
    );
  };

  render() {
    const { currentNote, debug } = this.props;
    const note = currentNote ? currentNote.toAbcString() : null;
    return (
      <div style={{ textAlign: 'center' }}>
        {debug && this.renderDebug(currentNote)}
        <div style={{ position: 'relative', display: 'inline-block' }}>
          {this.renderSvg(note, currentNote ? currentNote.noteNumber : null)}
        </div>
      </div>
    );
  }

  renderDebug = note => {
    const isNoteInRange = note && 'CDEFGABc'.includes(note.toAbcString());
    return (
      <div>
        {!isNoteInRange && <div>NOTA NON DISPONIBILE</div>}
        <div>{note && note.toString()}</div>
      </div>
    );
  };
}

export default Xylophone;
